import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { logMarketplacePages } from "@/utils/marketplacePageTrace";
import { logDemandGridStats } from "@/lib/demandGridGenerator";
import { logDemandCaptureStats } from "@/lib/demandSignalCapture";

console.log("main.tsx: Starting application initialization");

// DEV-only: Log AI Demand Intelligence System stats on startup
if (import.meta.env.DEV) {
  console.group("🧠 AI DEMAND INTELLIGENCE SYSTEM");
  console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
  console.log("📡 SEO pages act as demand sensors");
  console.log("🔒 Country detection is READ-ONLY (locked)");
  console.log("📊 Signal states: Detected → Confirmed → Active");
  console.log("🎯 Lane recommendations auto-generated from signals");
  console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
  console.groupEnd();
  
  // Log marketplace page audit
  logMarketplacePages();
  
  // Log demand grid stats
  logDemandGridStats();
  
  // Log demand signal capture stats
  logDemandCaptureStats();
  
  // Expose audit functions globally for debugging
  (window as any).logMarketplacePages = logMarketplacePages;
  (window as any).logDemandGridStats = logDemandGridStats;
  (window as any).logDemandCaptureStats = logDemandCaptureStats;
  
  console.log("🔧 DEV: Audit functions exposed globally:");
  console.log("   - logMarketplacePages()");
  console.log("   - logDemandGridStats()");
  console.log("   - logDemandCaptureStats()");
}

// Global error handlers for debugging
window.addEventListener("error", (event) => {
  console.error("Global error:", event.error);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event.reason);
});

const rootElement = document.getElementById("root");

if (rootElement) {
  try {
    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } catch (error) {
    console.error("main.tsx: Failed to render App:", error);
    rootElement.innerHTML = '<div style="padding: 20px; color: red;">Failed to load application. Check console for details.</div>';
  }
} else {
  console.error("main.tsx: Root element not found!");
}
